import { msgs } from "../define";

export const common = msgs({
  en: {
    "app.name": "Senvia POS",
    "common.loading": "Loading…",
    "common.retry": "Try again",
    "common.save": "Save",
    "common.saving": "Saving…",
    "common.saved": "Saved",
    "common.autosaved": "All changes saved",
    "common.cancel": "Cancel",
    "common.back": "Back",
    "common.next": "Continue",
    "common.skip": "Skip for now",
    "common.close": "Close",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.remove": "Remove",
    "common.delete": "Delete",
    "common.done": "Done",
    "common.search": "Search",
    "common.optional": "Optional",
    "common.required": "Required",
    "common.yes": "Yes",
    "common.no": "No",
    "common.none": "None",
    "common.name": "Name",
    "common.email": "Email",
    "common.phone": "Phone",
    "common.address": "Address",
    "common.notes": "Notes",
    "common.status": "Status",
    "common.total": "Total",
    "common.date": "Date",
    "common.time": "Time",
    "common.minutes": "{n} min",
    "common.working": "Working…",
    "common.confirm": "Confirm",
    "common.signOut": "Sign out",
    "common.branch": "Branch",
    "common.salon": "Salon",
    "common.language": "Language",
    "common.workspace": "Workspace",
    "common.offline": "You're offline. Changes can't be saved until the connection is back.",
    "common.addon": "Add-on",
    "common.comingSoon": "Coming soon",
    "common.comingSoonBody": "This module is planned for a later release.",
    "common.menu": "Menu",
    "common.closeMenu": "Close menu",
    "common.account": "Account",
    "common.today": "Today",
    "common.from": "from",
    "common.learnMore": "Learn more",
    "error.network": "Can't reach the server. Check the connection and try again.",
    "error.generic": "Something went wrong. Please try again.",
    "error.forbidden": "You don't have permission to do that.",
    "error.onboarding": "Finish setting up your salon first.",
    "error.validation": "Please check the highlighted fields.",
    "error.rate": "Too many attempts. Please wait a few minutes and try again.",
    "denied.title": "Not available for your role",
    "denied.body": "Ask the salon owner if you need access.",
    "ws.owner": "Owner",
    "ws.checkout": "Front desk",
    "ws.employee": "My work",
    "ws.platform": "Platform admin",
    "nav.overview": "Overview",
    "nav.appointments": "Appointments",
    "nav.pos": "Checkout",
    "nav.customers": "Customers",
    "nav.services": "Services",
    "nav.team": "Team",
    "nav.settings": "Settings",
    "nav.addons": "Add-ons",
    "nav.packages": "Packages",
    "nav.promotions": "Promotions",
    "nav.inventory": "Inventory",
    "nav.website": "Website & online booking",
    "nav.payroll": "Payroll",
    "nav.branches": "Branches",
    "nav.orders": "Orders & refunds",
    "nav.cash": "Open/close business (cash drawer)",
    "nav.activity": "My activity",
    "nav.lock": "Lock screen",
    "nav.myDay": "My day",
    "nav.myPayroll": "My earnings",
    "nav.attendance": "Attendance",
    "nav.tenants": "Salons",
    "nav.group.customers": "Customers & members",
    "nav.group.catalog": "Services & products",
    "nav.group.team": "Team",
    "nav.group.stock": "Stock & purchasing",
    "nav.group.finance": "Finance",
    "nav.group.online": "Online",
    "nav.search": "Search features…",
    "nav.search.none": "No matching features",
    "nav.group.front": "Front desk",
    "nav.group.me": "Me",
    "team.role.owner": "Owner",
    "team.role.manager": "Manager",
    "team.role.cashier": "Cashier",
    "team.role.staff": "Staff",
    "status.pending_payment": "Pending payment",
    "status.confirmed": "Confirmed",
    "status.checked_in": "Checked in",
    "status.in_service": "In service",
    "status.completed": "Completed",
    "status.cancelled": "Cancelled",
    "status.no_show": "No-show",
    "status.open": "Open",
    "status.held": "On hold",
    "status.paid": "Paid",
    "status.voided": "Voided",
    "status.closed": "Closed",
    "status.active": "Active",
    "status.trialing": "Trial",
    "status.onboarding": "Setting up",
    "status.suspended": "Suspended",
    "day.0": "Sunday", "day.1": "Monday", "day.2": "Tuesday", "day.3": "Wednesday", "day.4": "Thursday", "day.5": "Friday", "day.6": "Saturday",
    "dayShort.0": "Sun", "dayShort.1": "Mon", "dayShort.2": "Tue", "dayShort.3": "Wed", "dayShort.4": "Thu", "dayShort.5": "Fri", "dayShort.6": "Sat",
    "shell.verifyBanner": "Confirm your email address to keep your account secure.",
    "shell.resend": "Resend email",
    "shell.resent": "Verification email sent.",
    "shell.switchSalon": "Switch salon",
    "shell.switchWorkspace": "Switch view",
  },
  zh: {
    "app.name": "Senvia POS",
    "common.loading": "加载中…",
    "common.retry": "重试",
    "common.save": "保存",
    "common.saving": "保存中…",
    "common.saved": "已保存",
    "common.autosaved": "所有更改已保存",
    "common.cancel": "取消",
    "common.back": "上一步",
    "common.next": "继续",
    "common.skip": "暂时跳过",
    "common.close": "关闭",
    "common.edit": "编辑",
    "common.add": "添加",
    "common.remove": "移除",
    "common.delete": "删除",
    "common.done": "完成",
    "common.search": "搜索",
    "common.optional": "可选",
    "common.required": "必填",
    "common.yes": "是",
    "common.no": "否",
    "common.none": "无",
    "common.name": "名称",
    "common.email": "邮箱",
    "common.phone": "电话",
    "common.address": "地址",
    "common.notes": "备注",
    "common.status": "状态",
    "common.total": "合计",
    "common.date": "日期",
    "common.time": "时间",
    "common.minutes": "{n} 分钟",
    "common.working": "处理中…",
    "common.confirm": "确认",
    "common.signOut": "退出登录",
    "common.branch": "分店",
    "common.salon": "店铺",
    "common.language": "语言",
    "common.workspace": "工作区",
    "common.offline": "当前离线，恢复网络前无法保存更改。",
    "common.addon": "加购模块",
    "common.comingSoon": "即将推出",
    "common.comingSoonBody": "该模块将在后续版本中推出。",
    "common.menu": "菜单",
    "common.closeMenu": "关闭菜单",
    "common.account": "账户",
    "common.today": "今天",
    "common.from": "起",
    "common.learnMore": "了解更多",
    "error.network": "无法连接服务器，请检查网络后重试。",
    "error.generic": "出错了，请重试。",
    "error.forbidden": "您没有执行此操作的权限。",
    "error.onboarding": "请先完成店铺设置。",
    "error.validation": "请检查标出的字段。",
    "error.rate": "尝试次数过多，请稍等几分钟再试。",
    "denied.title": "您的角色无法使用此功能",
    "denied.body": "如需访问权限，请联系店主。",
    "ws.owner": "店主",
    "ws.checkout": "前台",
    "ws.employee": "我的工作",
    "ws.platform": "平台管理",
    "nav.overview": "概览",
    "nav.appointments": "预约",
    "nav.pos": "收银",
    "nav.customers": "顾客",
    "nav.services": "服务项目",
    "nav.team": "团队",
    "nav.settings": "设置",
    "nav.addons": "加购模块",
    "nav.packages": "套餐卡",
    "nav.promotions": "促销",
    "nav.inventory": "库存",
    "nav.website": "官网与在线预约",
    "nav.payroll": "工资管理",
    "nav.branches": "分店",
    "nav.orders": "订单与退款",
    "nav.cash": "营业 / 钱箱",
    "nav.activity": "我的记录",
    "nav.lock": "锁屏",
    "nav.myDay": "我的今天",
    "nav.myPayroll": "我的收入",
    "nav.attendance": "考勤",
    "nav.tenants": "店铺",
    "nav.group.customers": "顾客与会员",
    "nav.group.catalog": "服务与商品",
    "nav.group.team": "团队",
    "nav.group.stock": "库存与采购",
    "nav.group.finance": "财务",
    "nav.group.online": "线上",
    "nav.search": "搜索功能…",
    "nav.search.none": "没有匹配的功能",
    "nav.group.front": "前台",
    "nav.group.me": "我",
    "team.role.owner": "店主",
    "team.role.manager": "店长",
    "team.role.cashier": "收银员",
    "team.role.staff": "员工",
    "status.pending_payment": "待付款",
    "status.confirmed": "已确认",
    "status.checked_in": "已到店",
    "status.in_service": "服务中",
    "status.completed": "已完成",
    "status.cancelled": "已取消",
    "status.no_show": "爽约",
    "status.open": "进行中",
    "status.held": "已挂单",
    "status.paid": "已付款",
    "status.voided": "已作废",
    "status.closed": "已关闭",
    "status.active": "使用中",
    "status.trialing": "试用中",
    "status.onboarding": "设置中",
    "status.suspended": "已暂停",
    "day.0": "星期日", "day.1": "星期一", "day.2": "星期二", "day.3": "星期三", "day.4": "星期四", "day.5": "星期五", "day.6": "星期六",
    "dayShort.0": "周日", "dayShort.1": "周一", "dayShort.2": "周二", "dayShort.3": "周三", "dayShort.4": "周四", "dayShort.5": "周五", "dayShort.6": "周六",
    "shell.verifyBanner": "请验证您的邮箱，以保障账户安全。",
    "shell.resend": "重新发送邮件",
    "shell.resent": "验证邮件已发送。",
    "shell.switchSalon": "切换店铺",
    "shell.switchWorkspace": "切换视图",
  },
  ms: {
    "app.name": "Senvia POS",
    "common.loading": "Memuatkan…",
    "common.retry": "Cuba lagi",
    "common.save": "Simpan",
    "common.saving": "Menyimpan…",
    "common.saved": "Disimpan",
    "common.autosaved": "Semua perubahan disimpan",
    "common.cancel": "Batal",
    "common.back": "Kembali",
    "common.next": "Teruskan",
    "common.skip": "Langkau dahulu",
    "common.close": "Tutup",
    "common.edit": "Sunting",
    "common.add": "Tambah",
    "common.remove": "Buang",
    "common.delete": "Padam",
    "common.done": "Selesai",
    "common.search": "Cari",
    "common.optional": "Pilihan",
    "common.required": "Wajib",
    "common.yes": "Ya",
    "common.no": "Tidak",
    "common.none": "Tiada",
    "common.name": "Nama",
    "common.email": "E-mel",
    "common.phone": "Telefon",
    "common.address": "Alamat",
    "common.notes": "Nota",
    "common.status": "Status",
    "common.total": "Jumlah",
    "common.date": "Tarikh",
    "common.time": "Masa",
    "common.minutes": "{n} min",
    "common.working": "Sedang diproses…",
    "common.confirm": "Sahkan",
    "common.signOut": "Log keluar",
    "common.branch": "Cawangan",
    "common.salon": "Salun",
    "common.language": "Bahasa",
    "common.workspace": "Ruang kerja",
    "common.offline": "Anda di luar talian. Perubahan tidak boleh disimpan sehingga sambungan pulih.",
    "common.addon": "Tambahan",
    "common.comingSoon": "Akan datang",
    "common.comingSoonBody": "Modul ini dirancang untuk keluaran akan datang.",
    "common.menu": "Menu",
    "common.closeMenu": "Tutup menu",
    "common.account": "Akaun",
    "common.today": "Hari ini",
    "common.from": "dari",
    "common.learnMore": "Ketahui lanjut",
    "error.network": "Tidak dapat menghubungi pelayan. Semak sambungan dan cuba lagi.",
    "error.generic": "Berlaku ralat. Sila cuba lagi.",
    "error.forbidden": "Anda tiada kebenaran untuk tindakan ini.",
    "error.onboarding": "Lengkapkan persediaan salun anda dahulu.",
    "error.validation": "Sila semak medan yang ditanda.",
    "error.rate": "Terlalu banyak percubaan. Sila tunggu beberapa minit dan cuba lagi.",
    "denied.title": "Tidak tersedia untuk peranan anda",
    "denied.body": "Minta akses daripada pemilik salun jika perlu.",
    "ws.owner": "Pemilik",
    "ws.checkout": "Kaunter",
    "ws.employee": "Kerja saya",
    "ws.platform": "Pentadbir platform",
    "nav.overview": "Gambaran",
    "nav.appointments": "Temujanji",
    "nav.pos": "Kaunter bayaran",
    "nav.customers": "Pelanggan",
    "nav.services": "Perkhidmatan",
    "nav.team": "Pasukan",
    "nav.settings": "Tetapan",
    "nav.addons": "Tambahan",
    "nav.packages": "Pakej",
    "nav.promotions": "Promosi",
    "nav.inventory": "Inventori",
    "nav.website": "Laman web & tempahan dalam talian",
    "nav.payroll": "Gaji",
    "nav.branches": "Cawangan",
    "nav.orders": "Pesanan & bayaran balik",
    "nav.cash": "Buka/tutup perniagaan (laci tunai)",
    "nav.activity": "Aktiviti saya",
    "nav.lock": "Kunci skrin",
    "nav.myDay": "Hari saya",
    "nav.myPayroll": "Pendapatan saya",
    "nav.attendance": "Kehadiran",
    "nav.tenants": "Salun",
    "nav.group.customers": "Pelanggan & ahli",
    "nav.group.catalog": "Perkhidmatan & produk",
    "nav.group.team": "Pasukan",
    "nav.group.stock": "Stok & pembelian",
    "nav.group.finance": "Kewangan",
    "nav.group.online": "Dalam talian",
    "nav.search": "Cari fungsi…",
    "nav.search.none": "Tiada fungsi sepadan",
    "nav.group.front": "Kaunter",
    "nav.group.me": "Saya",
    "team.role.owner": "Pemilik",
    "team.role.manager": "Pengurus",
    "team.role.cashier": "Juruwang",
    "team.role.staff": "Staf",
    "status.pending_payment": "Menunggu bayaran",
    "status.confirmed": "Disahkan",
    "status.checked_in": "Telah tiba",
    "status.in_service": "Sedang dilayan",
    "status.completed": "Selesai",
    "status.cancelled": "Dibatalkan",
    "status.no_show": "Tidak hadir",
    "status.open": "Terbuka",
    "status.held": "Ditangguhkan",
    "status.paid": "Dibayar",
    "status.voided": "Dibatalkan (void)",
    "status.closed": "Ditutup",
    "status.active": "Aktif",
    "status.trialing": "Percubaan",
    "status.onboarding": "Dalam persediaan",
    "status.suspended": "Digantung",
    "day.0": "Ahad", "day.1": "Isnin", "day.2": "Selasa", "day.3": "Rabu", "day.4": "Khamis", "day.5": "Jumaat", "day.6": "Sabtu",
    "dayShort.0": "Ahd", "dayShort.1": "Isn", "dayShort.2": "Sel", "dayShort.3": "Rab", "dayShort.4": "Kha", "dayShort.5": "Jum", "dayShort.6": "Sab",
    "shell.verifyBanner": "Sahkan alamat e-mel anda untuk memastikan akaun anda selamat.",
    "shell.resend": "Hantar semula e-mel",
    "shell.resent": "E-mel pengesahan telah dihantar.",
    "shell.switchSalon": "Tukar salun",
    "shell.switchWorkspace": "Tukar paparan",
  },
});
